import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import { get } from "lodash";
import { usePreCheckInContext } from "./contexts/PreCheckInContext";
import Guests from "../../model/guests";
import defaultAvatar from "../../assets/precheckin/avatarDefaultMale0.png";
import "./test.css";

const ChooseGuestsToRegister = () => {
  const {
    language,
    propertyUid,
    bookingNumber,
    lastName,
    userEmail,
    data: { presets, booking, guests },
    components: { PreCheckInHeader, PreCheckInContainer },
    func: { updateGuests },
  } = usePreCheckInContext();

  const history = useHistory();
  const { t } = useTranslation();
  const [cloneGuests, setCloneGuests] = useState(new Guests());
  useEffect(() => {
    if (guests && cloneGuests.numberOfGuests() === 0) {
      setCloneGuests(guests);
      return;
    }
  }, [guests, cloneGuests]);

  const handleCheckboxes = (index, guest) => {
    guest.editable = !guest.editable;
    cloneGuests.UpdateByNumber(index, guest);
    setCloneGuests(new Guests(cloneGuests.allGuests()));
  };

  const continueBtn = () => {
    updateGuests(cloneGuests);
    history.push(
      `/pre-checkin/${propertyUid}/book-detail/${encodeURIComponent(
        bookingNumber
      )}/${encodeURIComponent(
        lastName
      )}?language=${language}&email=${encodeURIComponent(userEmail)}`
    );
  };

  const renderGuestList = (items) => {
    const item = items && items.item;
    if (!item) {
      return null;
    }

    if (
      item?.accountExist === items?.invitationList ||
      (!item.email && item.ageGroup !== "ADULT") ||
      (!item.mainGuest && item.preCheckedInCompleted)
    ) {
      return null;
    }

    const guestName = `${item.firstName} ${item.lastName}`;
    const guestEmail = item && item.email;
    const arrayOfAdditionalGuestChildren = (item && item.children) || [];
    const readyPreCheckIn = booking.status === "ready_to_pre_checkin";
    return (
      <>
        <div
          style={{ flex: 1, marginBottom: "10px" }}
          className="flex space-x-4 items-center justify-between">
          {item.preCheckedInCompleted && guestEmail ? (
            <div className="w-28 flex-shrink-0">
              <img
                src={get(item, "avatar.thumbnail.url", defaultAvatar)}
                alt="avatar"
                className="rounded-full w-28 h-28 object-cover"
              />
            </div>
          ) : (
            <div className="w-28 flex-shrink-0">
              <img
                src={get(item, "avatar.thumbnail.url", defaultAvatar)}
                alt="avatar"
                className="rounded-full w-28 h-28 object-cover"
              />
            </div>
          )}
          <div
            className="flex flex-col flex-1"
            style={{ lineBreak: "anywhere", marginRight: "4rem" }}>
            <p className="mb-1">{guestName}</p>
            {item.mainGuest ? (
              <button
                className={`bg-white border w-36 py-1 type-title normal capitalize ${presets.buttonStyleName}`}
                style={{
                  color: presets.appHomeTextDetailsPrecheckin,
                  backgroundColor: presets.backgroundColorTopBar,
                }}>
                {t("PRIMARY")}
              </button>
            ) : guestEmail ? (
              <p className="break-words">{guestEmail}</p>
            ) : null}
          </div>
          <div className="flex-shrink-0">
            {item.preCheckedInCompleted ? null : item.currentGuest &&
              readyPreCheckIn ? null : !item.currentGuest &&
              booking.mainGuestIsPrimaryGuest ? (
              <div className="w-8 mr-8 flex items-center">
                <div className="flex items-center justify-center w-full mb-12">
                  <label className="flex items-center cursor-pointer">
                    <div className="relative">
                      <input
                        onChange={() => handleCheckboxes(items.index, item)}
                        type="checkbox"
                        checked={item.editable}
                        className="sr-only"
                      />
                      <div
                        className="block h-10 rounded-full"
                        style={{
                          width: "4.5rem",
                          backgroundColor: item.editable
                            ? presets.backgroundColorTopBar
                            : "#e5e7eb",
                        }}></div>
                      <div className="dot absolute left-1 top-1 bg-white w-8 h-8 rounded-full transition"></div>
                    </div>
                  </label>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {arrayOfAdditionalGuestChildren &&
          arrayOfAdditionalGuestChildren.map((item, index) => (
            <React.Fragment key={index}>
              {renderGuestList({
                item: item.item,
                childOfMainGuest: false,
              })}
            </React.Fragment>
          ))}
      </>
    );
  };
  const invitationCount = () =>
    guests
      .allGuests()
      .reduce(
        (count, guest) =>
          guest.accountExist || guest.mainGuest ? count : count + 1,
        0
      );

  return (
    <>
      <PreCheckInContainer containerName="choose-guests-to-register">
        <PreCheckInHeader
          title={t("GUEST_LIST_MANAGEMENT")}
          headerLink
        />
        {cloneGuests && booking && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <div className="flex flex-col h-full">
                <div className="flex mb-10 w-full">
                  <div className="m-auto">
                    <p
                      className="mb-12 type-normal larger"
                      style={{ color: presets?.titleColor }}>
                      {t("CHOOSE_REGISTER_GUEST_TEXT")}
                    </p>

                    <hr
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        borderColor: presets?.appHomeRowDividerColor,
                      }}
                    />

                    <div>
                      <p className="capitalize">{`${t("GUESTS")} (${
                        booking?.totalCurrentGuest
                      } ${t("OF")} ${booking?.totalGuests})`}</p>
                    </div>

                    <div className="w-full mb-4 py-8 relative">
                      {cloneGuests.allGuests().map((item, index) => (
                        <React.Fragment key={index}>
                          {renderGuestList({
                            item,
                            index,
                            invitationList: false,
                          })}
                        </React.Fragment>
                      ))}
                      {invitationCount() > 0 &&
                        cloneGuests.allGuests().map((item, index) => (
                          <React.Fragment key={index}>
                            {renderGuestList({
                              item,
                              index,
                              invitationList: true,
                            })}
                          </React.Fragment>
                        ))}
                    </div>
                  </div>
                </div>
                <button
                  className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                  style={{
                    backgroundColor: presets.backgroundColorTopBar,
                    color: presets.appHomeTextCallToAction,
                  }}
                  onClick={() => continueBtn()}>
                  {t("CONTINUE")}
                </button>
              </div>
            </section>
            <button
              className="app-button-mobile type-title medium "
              style={{
                backgroundColor: presets.backgroundColorTopBar,
                color: presets.appHomeTextCallToAction,
                position: "fixed",
                bottom: 0,
                left: 0,
              }}
              onClick={() => continueBtn()}>
              {t("CONTINUE")}
            </button>
          </>
        )}
      </PreCheckInContainer>
    </>
  );
};

export default withTranslation()(ChooseGuestsToRegister);
